<template>
  <div id="app">
    <header-module v-if="!hideHeader"></header-module>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" class="min-1280" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" class="min-1280" />
    <footer-module v-if="!$route.meta.hideLayout"></footer-module>
  </div>
</template>

<script>
import HeaderModule from "@/components/HeaderModule";
import FooterModule from "@/components/FooterModule";
export default {
  name: "App",
  components: {
    HeaderModule,
    FooterModule,
  },
  computed: {
    hideHeader() {
      return (
        this.$route.meta.hideLayout ||
        (
          this.$route.name === "WorkCompetitionDetail" &&
          this.$route.query.source === "school-works"
        )
      );
    },
  },
};
</script>
<style lang="scss">
.min-1280 {
  min-width: 1280px;
}
</style>
